import React, { useState, useEffect, useCallback, useRef } from "react";
import MessageIcon from "@mui/icons-material/Message";
import Box from "@mui/material/Box";
// import CardMedia from "@mui/material/CardMedia";
import { Button, Card, Divider, p, Typography } from "@mui/material";
// import TextField from "@mui/material/TextField";
import { keyframes } from "@mui/system";
import { styled } from "@mui/material/styles";
import NoImage from "../../images/resources/noImage.jpg";
import theme from "./theme";
import { auctionsLive,postPlaceBid,auctionsLiveDeclarator} from "../../Model/Auction";
import "./Center.css";
import Chat from "./chat";
import Drawer from "./drawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getUser } from "../../Model/LocalStorage";
// import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { getToken } from "../../Model/User";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import GavelIcon from '@mui/icons-material/Gavel';

import { Token } from "@mui/icons-material";

const blink = keyframes`
from { opacity: 0; }
to { opacity: 1; }
`;

const BlinkedBox = styled("div")({
color: "red",
animation: `${blink} 1s linear infinite`,
});

// Draggable dialog wrapper
function PaperComponent(props) {
const nodeRef = useRef(null);
return (
  <Draggable
    nodeRef={nodeRef}
    handle="#draggable-dialog-title"
    cancel={'[class*="MuiDialogContent-root"]'}
  >
    <Paper {...props} ref={nodeRef} />
  </Draggable>
);
}

// Main Component
const Midlayout = ({
socket,
mediadQuery,
room,
titleAuction,
details,
}) => {
const [sold, setSold] = useState("");
const [getData, setGetData] = useState([]);
const [image, setImage] = useState([]);
const [status, setStatus] = useState("");
const [announcement, setAnnouncement] = useState("");
const [switchMode, setSwitch] = useState(true);
const matchesPhone = useMediaQuery("(min-width:700px)");
const [more, setMore] = useState(false);
const [username, setUsername] = useState("");
const [auctionID, setAuctionID] = useState("");
const [setID, setIDset] = useState("");
const [lotNumber, setlotNumber] = useState("");
const [bidhistory, setBidHistory] = useState([]);
const [highestBid, setHighestBid] = useState(0);
const [userId, setUserId] = useState("");
const [highestNumber, setHighest] = useState("");
const [group, setGroup] = useState("");
const token = getToken();
const [opendragg, setOpendragg] = React.useState(false);
const [open, setOpen] = React.useState(true);

const handleMore = () => {
  setMore(prev => !prev);
};

// Helper to display sold status
const getSoldOverlay = (status) => {
  const styles = {
    SOLD: { color: "#59bb59", text: "SOLD", className: "statusCss" },
    UNSOLD: { color: "#ff4949", text: "UNSOLD", className: "statusUnsold" },
    PASS: { color: "#0bf8bf", text: "PASS", className: "statusUnsold" },
    RESERVE_NOT_MET: {
      color: "#fffd00",
      text: "RESERVE NOT MET",
      className: "statusUnsold",
      fontSize: 45,
    },
  };

  const item = styles[status];
  if (!item) return null;

  return (
    <div className="overlay11" style={{ color: item.color }}>
      <div className={item.className} style={{ fontSize: item.fontSize }}>
        {item.text}
      </div>
    </div>
  );
};

const ListData = useCallback(async () => {
  try {

    let results;
    if(group === "ADMIN"){
       results = await auctionsLiveDeclarator();
    }else{
     results = await auctionsLive();
    }

    if (results?.success) {
      const lotDetails = results.lot.details?.[0];

      setSold("");
      setGetData(results.lot.details || []);
      setlotNumber(lotDetails?.lot_number || "");
      setImage(results.lot.image_lot || []);
      setIDset(results.auction_details?.id || "");
      setAuctionID(results.auction_details?.auction_id || "");
setStatus(results.lot.details[0].lot_status);
      const price = lotDetails?.hp
        ? results.increment
        : lotDetails?.starting_price;

        setHighest(Math.max(...results.bid_history.map((o) => o.hammer)));

      setHighestBid(price || 0);
      setBidHistory(results.bid_history || []);
    }
  } catch (error) {

    console.error("ListData error:", error);
  }
}, []);


const incrementCount = useCallback( (auctionID, setID, lotNumber, highestBid) => {
  try {
 
  
    async function postBidFunction() {
      const ArrayData = {
        auction_id: auctionID,
        setId: setID,
        lot_number: lotNumber,
        amount: highestBid,
      };
  
     const results = await postPlaceBid(ArrayData);
      const messageData = {
        room: room,
        status: results?.success,
        amount: highestBid,
        increment: highestBid,
      };



    if (results?.success ===  true) {

      socket.emit("send_Bid_amount", messageData);

      return await ListData();
    } else {
      alert(`Error: ${results?.msg || "Unknown error"}`);
    }

    }
  
    postBidFunction().catch(console.error);


  
    

  } catch (error) {
    console.error("Bid error:", error);
  }
}, [auctionID, setID, lotNumber, highestBid, socket, room, ListData]);

useEffect(() => {



  const initializeUser = async () => {
    try {
      const getuser = await getUser();
      setUserId(getuser.id);
      setUsername(getuser.email);
      setGroup(getuser.group);

      socket.emit("ConnectedUser", {
        userId: getuser.id,
        email: getuser.email,
        group: getuser.group,
      });
    } catch (error) {
      console.error("User initialization failed:", error);
    }
  };

  initializeUser();

  try {
    const lotDetails = details?.lot?.details?.[0];

    setImage(details?.lot?.image_lot || []);
    setAnnouncement(details?.announcement?.[0]?.announcement || "");
    // setStatus(lotDetails?.lot_status || "");
    setStatus(details.lot.details[0].lot_status);
    if (lotDetails?.lot_status) {
      setSold(getSoldOverlay(lotDetails.lot_status));
    }

    setGetData(details?.lot?.details || []);
    setIDset(details?.auction_details?.id || "");
    setAuctionID(details?.auction_details?.auction_id || "");
    setlotNumber(lotDetails?.lot_number || "");
    // alert(Math.max(...details.bid_history.map((o) => o.hammer)))
    setHighest(Math.max(...details.bid_history.map((o) => o.hammer)));
    setHighestBid(
      lotDetails?.hp
        ? details.increment
        : lotDetails?.starting_price || 0
    );

    setBidHistory(details?.bid_history || []);
  } catch (error) {
   
    console.error("Error parsing details:", error);
  }

  const handleMessage = (data) => {
    setAnnouncement(data.message);
  };

  const handleStatus = (data) => {
    const { message } = data;
    setStatus(message);

    if (["SOLD", "UNSOLD", "PASS", "RESERVE_NOT_MET"].includes(message)) {
      setSold(getSoldOverlay(message));
    } else if (message === "NEXTSLOT" || message === "PASS") {
      setTimeout(() => ListData(), 1000);
    } else {
      setSold("");
    }
  };





  
  socket.on("receiveMessage", handleMessage);
  socket.on("receive_status", handleStatus);

  return () => {
   
    socket.off("receiveMessage", handleMessage);
    socket.off("receive_status", handleStatus);
  };
}, [socket, details, ListData]);


useEffect(()=> {

  
    socket.on("receive_bid_amount", (data) => {
      if (data.status === 1 || data.status === 2 ) {

        return ListData('',group);

      }else if (data.status === true) {
       
    
        // window.scrollTo(0, 0)
        return ListData('',group);
      } else {
        
      }
    });
 

  return () => {
    socket.off("receive_bid_amount"); // Clean up!

  };
},[socket,group])

const handleClose = () => {
  setOpen(!open);
};

const dragghandleClose = () => {
  setOpendragg(false);
};



  return (
    <>
  
    {/* <Button onClick={dragghandleClickOpen} 
    variant="outlined" 
    startIcon={<PlayCircleIcon />}
    style={{ background: '#ce1b37',
    color: 'white',
    fontSize: 12,
    right:0,position: 'absolute',
    zIndex: 9,
    borderRadius:5,
    visibility: mediadQuery === false ? "hidden" : "vissible",}}>
     Watch live</Button> */}


 
              <BlinkedBox
                style={{

                  fontSize: 18,
                  // visibility: status !== "" ? "visible" : "hidden",
                  // visibility:
                  //   status === "FAIR_WARNING" || status === "OPEN"
                  //     ? "visible"
                  //     : "hidden",
                }}
              >
                <div className="boxStatusOne" style={{ position: "static", marginTop: mediadQuery === false ? 15:0, display:  status === "FAIR_WARNING" ? 'block':'none',}}>
                  <div
                    className="boxStatus"
                    
                    style={{
                     
                        backgroundColor:
                        status === "FAIR_WARNING" ? "#eee608" : "",
                        color: "black",
                    }}
                  >
                    <p style={{ margin: "auto",fontWeight: 'bold' }}>{   status === "FAIR_WARNING" ? status: ''}</p>
                  </div>
                </div>
              </BlinkedBox>
        
      {mediadQuery === false ? (
        <div >


        {/* <p
          gutterBottom
          style={{ fontWeight: "bold", textAlign: "center" }}
        >
          {titleAuction}
        </p>  */}
        </div>
      ) : (
        ""
      )}

      <div >
        <div
          className=""
          style={{
            marginTop:10,
            maxWidth: mediadQuery === false ? "" : "100%",
            margin: mediadQuery === false ? "" : "auto",
          }}
        >
          <div
            className="container11"
            style={{
            
              // border: "1px solid rgb(204, 204, 204)",
              // height: mediadQuery === false ? 300 : 400,
              // width: mediadQuery === false ? 300 : "",
              width:
                mediadQuery === false
                  ? image.slice(1).length
                    ? "65%"
                    : switchMode === true
                    ? "80%"
                    : "100%"
                  : "50",
                 margin: mediadQuery === false ? "auto" : "",
              // border: "1px solid #ccc",
            }}
          >

            {mediadQuery === false ? (
              <div style={{   marginBottom: mediadQuery === false ? 0 : 0,border: "1px solid rgb(204, 204, 204)",}}>
                 <div style={{
                        // display: switchMode === true ? "inline-block" : "none", 
                        backgroundImage: `url(${image.length ? image[0].img_url : NoImage})`,
                        backgroundColor: "#ffffff",
                        width: "100%",
                        height:  mediadQuery === false ? 200 : 370,
                        // display: "inline-block",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        padding: 10,
                         }} >
                 </div>

                {/* <img
                  style={{ display: switchMode === true ? "inline" : "none" }}
                  className="image11"
                  src={image.length ? image[0].img_url : NoImage}
                /> */}

                {/* <div
                  className="image11"
                  style={{ display: switchMode === true ? "none" : "inline-block" }}
                >
                  <video
                    style={{ width: "100%", paddingTop: 20 }}
                    loop
                    controls
                    autoPlay
                    muted
                    playsInline
                  ></video>
                </div> */}
              </div>
            ) : (
              <img
                // style={{display: switchMode === true ? 'inline': 'none'}}
                className="image11"
                src={image.length ? image[0].img_url : NoImage}
              />
            )}

            {switchMode === false ? "" : sold}
            {/* <div class="overlay_sold">Sold</div> */}
          </div>
          {/* <div style={{ display: image.slice(1).length ? "block" : "none", }}>
          <div style={{ display: switchMode === true ? "inline-block" : "none" }}> */}
            {/* <div
              className=""
              style={{
                display: image.slice(1).length ? "block" : "none",
                maxWidth: mediadQuery === false ? "" : "100%",
                
                // margin: mediadQuery === false ? '' : "auto",
              }}
            > */}

   
            {/* <div
                style={{
                  display: "inline-flex",
                  justifyContent: "space-between",
                  height: 100,
                  marginTop: 20,
                  overflow: "auto",
                  // width: mediadQuery === false ? 300 : "",
                  margin: mediadQuery === false ? "auto" : "",
                }}
              >
                {image.slice(1).length ? (
                  image
                    .slice(1)
                    .map((val, i) => (
                      <div
                      className="centerImageOne"
                      style={{
                        border: '1px solid rgb(232, 232, 232)',
                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 5px',
                        display: switchMode === true ? "inline" : "none", 
                        backgroundImage: `url(${val.img_url})`,
                        backgroundColor: "#ffffff",
                        width: 100,
                        height: 100,
                        display: "inline-block",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        padding: 10,
                        marginRight:5
                      }}
                    ></div>
                    
                    ))
                ) : ("" )}
              </div> */}
          {/* </div> */}

      
          
        </div>
      </div>

      {mediadQuery === false ? (
        <div>
         
        </div>
      ) : (
        <div style={{ padding: 10, marginTop: 5 ,overflow: 'auto',
          height: 500}}>
          <div>

    <Box style={{width: '50%' ,margin: 'auto'}}>
         <Box sx={{marginBottom: 2 ,}} >
     
    {/* {group} */}
    {token === null ? (
          <div style={{ display: mediadQuery === true ? "block" : "none" }}>
            <Box>
              <Button
                variant="contained"
                onClick={(e) =>
                  incrementCount(auctionID, setID, lotNumber, highestBid)
                }
                fullWidth={true}
                sx={{
                  background: '#303131',
                  textTransform: 'capitalize',
                  borderTopRightRadius: 5,
                  borderTopLeftRadius: 5,
                  borderBottomRightRadius: 5,
                  borderBottomLeftRadius: 5,
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                Login to bid
              </Button>
            </Box>
          </div>
        ) :
<Button 
// startIcon={<GavelIcon sx={{color: 'white'}} />}
    disabled={
      bidhistory.filter(
        (val) =>
          val.userId === userId &&
          val.win_status === "WIN" &&
          val.hammer === highestNumber
      ).length ||
      status === "PENDING" ||
      status === "PAUSE" ||
      status === "SOLD"
      ? group === "ADMIN" ?false:true
      : false


      
    }
    onClick={(e) =>
      incrementCount(auctionID, setID, lotNumber, highestBid)
    }
    fullWidth={true}
    className={bidhistory.filter(
      (val) =>
        val.userId === userId &&
        val.win_status === "WIN" &&
        val.hammer === highestNumber
    ).length
      ?  "winning-buttonBlue"
      : "winning-buttonRed"}
      className={bidhistory.filter(
        (val) =>
          val.userId === userId &&
          val.win_status === "WIN" &&
          val.hammer === highestNumber
      ).length
        ?  "winning-buttonBlue"
        : "winning-buttonRed"}
      sx={{
        color: 'white',
        borderTopRightRadius: 5,
        borderTopLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderBottomLeftRadius: 5,
        fontSize: 20,
        fontWeight: "bold",
        background: bidhistory.filter(
          (val) =>
            val.userId === userId &&
            val.win_status === "WIN" &&
            val.hammer === highestNumber
        ).length
          ?  "linear-gradient(135deg, #2f94f8, #1976d2)"
          : "linear-gradient(135deg, #f02141, #ce1b37)",
        color: "#fff",
        ":hover": {
          bgcolor: "#a20b1b",
          color: "white",
        },
      }}>
  
    <div style={{color: 'white', textAlign: 'center',lineHeight: 1.2  }}>
  <div style={{ fontSize: '20px', }}>₱ {highestBid !== null ?highestBid.toLocaleString():0}</div>
  <div style={{ fontSize: '18px' , marginTOp: '-15px'}}>{bidhistory.filter(
        (val) =>
          val.userId === userId &&
          val.win_status === "WIN" &&
          val.hammer === highestNumber
      ).length
        ? "highest bidder"
        : "Place bid"}</div>
</div>

  </Button>}
    </Box>
  </Box>

   
           
   
 
            <Divider />
            <div  style={{display: 'flex', justifyContent: 'space-between', marginTop: 5}}>
            <p
              gutterBottom
              variant="h6"
              style={{ fontWeight: "bold",fontSize: 20 }}
            >
    &nbsp;
            </p> 

            {token !== null ? 
          <Button
          variant="contained"
            onClick={handleClose}
       
              style={{ fontWeight: "bold",fontSize: 12,textTransform: 'capitalize',height:25 }}
              startIcon={<MessageIcon style={{fontSize: 15 }}/>}
            >

<span> Chat with Us</span> 
            </Button>: ""}
            </div>

{details.length}
            {getData.map((val, i) => {
              let data =
                val.signed_dated + val.medium + val.size + val.property;
              return (
                <div key={i}>
                  {/* {data.length > 1000} */}

                  <Typography style={{ marginTop: 10,fontSize: 'Roboto","Helvetica","Arial",sans-serif'  }}>
                    <Typography
                    
                      style={{ fontSize: 18, fontWeight: "bold",fontSize: 'Roboto","Helvetica","Arial",sans-serif' }}
                      dangerouslySetInnerHTML={{ __html: val.artist === undefined ? "":val.artist}}
                    ></Typography>
                    <Typography
                      style={{ fontSize: 18, fontStyle: "italic",fontSize: 'Roboto","Helvetica","Arial",sans-serif'  }}
                      dangerouslySetInnerHTML={{ __html: val.title }}
                    ></Typography>
                  </Typography>

                  <Typography>
                    <Typography
                      style={{ fontSize: 16,fontSize: 'Roboto","Helvetica","Arial",sans-serif' }}
                      dangerouslySetInnerHTML={{ __html: val.signed_dated }}
                    ></Typography>

                    <Typography
                      style={{ fontSize: 16,fontSize: 'Roboto","Helvetica","Arial",sans-serif'  }}
                      dangerouslySetInnerHTML={{ __html: val.medium }}
                    ></Typography>

                    <Typography
                      style={{ fontSize: 16,fontSize: 'Roboto","Helvetica","Arial",sans-serif' }}
                      dangerouslySetInnerHTML={{ __html: val.property }}
                    ></Typography>
                  </Typography>

                  {data.length > 1000 ? (
                    <div style={{ marginTop: 15 }}>
                      {" "}
                      <Button
                        variant="outlined"
                        onClick={handleMore}
                        style={{ textTransform: "capitalize" }}
                      >
                        {" "}
                        {more === false ? "Read more" : "Less"}
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <p style={{ fontSize: 16}}   dangerouslySetInnerHTML={{__html: val.medium}} ></p>
                <p style={{ fontSize: 16}}  dangerouslySetInnerHTML={{__html: val.size}} ></p>
                <p style={{ fontSize: 16}}>{val.property}</p> */}
                </div>
              );
            })}

            {/* <Divider></Divider> */}
          </div>
          {/* <Box style={{ marginTop: 15 }}>
            <p style={{ fontWeight: "bold" }}>
              <MessageIcon /> Announcement :
            </p>
            <p
              style={{ fontSize: 14, whiteSpace: "pre-line", marginTop: 10 }}
            >
              {announcement}
            </p>
          </Box> */}
        </div>
      )}

    <div
        style={{
          zIndex: 99999,
          // position: "relative",
          bottom: matchesPhone === true ? 550 : 0,
          display: open === false ? "block" : "none",
        }}
      >
        <div
          style={{
            position: "fixed",
            bottom: matchesPhone === true ? 0 : 100,
            right: '36%',
            width: '30%',
            marginBottom: 30,
          }}  
        >
          <Drawer
    
            status={open}
            socket={socket}
            username={"admin@leon-gallery.com"}
            room={12835}
                  handleClose={handleClose}
                  sender={userId}
                />
        </div>
      </div>


    
      <Dialog
      
        open={opendragg}
        onClose={dragghandleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {titleAuction}
        </DialogTitle>
        <DialogContent sx={{padding: '0px 6px'}}>
        <div style={{  width: 500,}}>
            <iframe
              id="ifvideo"
              width="100%"
              height={`${matchesPhone === true ? "380" : "100%"}`}
              scrolling="no"
              frameborder="0"
              allowfullscreen=""
              src="https://demo.nanocosmos.de/nanoplayer/embed/1.3.3/nanoplayer.html?entry.rtmp.streamname=TKGUW-bCyQT&amp;playback.latencyControlMode=balancedadaptive"
            ></iframe>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={dragghandleClose}>
            Close
          </Button>
          {/* <Button onClick={handleClose}>Subscribe</Button> */}
        </DialogActions>
      </Dialog>



    </>
  );
}

export default Midlayout;

//"https://leongallery.sgp1.digitaloceanspaces.com/v2/private-sale/PRIVATE_SALE/69.jpg" "https://wallpapers.com/images/featured/hd-a5u9zq0a0ymy2dug.jpg"
